import { z } from "zod";
import { zStringId } from "../../utils";
import { USER_ROLES_ENUM } from "./role-statics";

export const zUserInfo = z.object({
  _id: zStringId(),
  email: z.string(),
  username: z.string(),
  roleId: z.string(),
  firstName: z.string(),
  lastName: z.string().optional(),
  country: z.string(),
  profileImage: z.string(),
  roleName: z.nativeEnum(USER_ROLES_ENUM),
  isOnboardingComplete: z.boolean().optional(),
});

/**
 * Included in the return of a successful login request.
 */
export type UserInfo = z.infer<typeof zUserInfo>;
